import { useMemo } from 'react';
import { IShopPreviewProps } from '~/components/ui/ShopPreview';
import { rage, useObservable } from '~/rage';
import { VehiclePaintType, WalletType } from '~/shared';
import { CategoryTypes } from '../components/CategoryTab';
import { useLayoutSelector } from '../redux';
import { useBuy } from './useBuy';

const useShopPreview = (): IShopPreviewProps => {
	const rimsColors = useObservable(
		rage.vehiclePaintShop.getVehicleRimsColors(),
	);
	const rimsColorsPrice = useObservable(
		rage.vehiclePaintShop.getVehicleRimsColorPrice(),
	);
	const paintGroups = useObservable(
		rage.vehiclePaintShop.getVehiclePaintTypes(),
	);
	const activeStage = useLayoutSelector((state) => state.carPaint.activeStage);
	const activeList = useLayoutSelector((state) => state.carPaint.activeList);
	const activeListIndex = useLayoutSelector(
		(state) => state.carPaint.activeListIndex,
	);
	const activeCategory = useLayoutSelector(
		(state) => state.carPaint.activeCategory,
	);
	const rimsColor = useLayoutSelector((state) => state.colorPicker.rimsColor);
	const activePaintGroup = useLayoutSelector(
		(state) => state.colorPicker.paintGroup,
	);
	const sectionIndex = useLayoutSelector(
		(state) => state.colorPicker.sectionIndex,
	);

	const { handleBuy } = useBuy();

	const visible = useMemo(
		() => activeStage !== 'category' && activeListIndex !== null,
		[activeStage, activeListIndex],
	);

	const selectedWindowTint = useMemo(
		() => activeList[activeListIndex || 0],
		[activeList, activeListIndex],
	);

	if (activeCategory === CategoryTypes.GlassTinting && selectedWindowTint) {
		return {
			visible,
			name: selectedWindowTint?.name,
			price: selectedWindowTint?.price,
			handlePayByCash: () => handleBuy(WalletType.Cash),
			handlePayByCard: () => handleBuy(WalletType.Bank),
		};
	}

	if (activeCategory === CategoryTypes.PaintingWheels) {
		const color = rimsColors.find((item) => item.index === rimsColor);

		return {
			visible: activeStage === 'paint',
			name: color?.name || '',
			price: rimsColorsPrice,
			handlePayByCash: () => handleBuy(WalletType.Cash),
			handlePayByCard: () => handleBuy(WalletType.Bank),
		};
	}

	if (activeCategory === CategoryTypes.PaintingWorks && sectionIndex === 1) {
		const group = paintGroups.find(
			(item) => item.type === VehiclePaintType.Classic,
		);

		return {
			visible: activeStage === 'paint',
			name: group?.name || '',
			price: group?.price || 0,
			handlePayByCash: () => handleBuy(WalletType.Cash),
			handlePayByCard: () => handleBuy(WalletType.Bank),
		};
	}

	return {
		visible: activeStage === 'paint',
		name: activePaintGroup?.name || '',
		price: activePaintGroup?.price || 0,
		handlePayByCash: () => handleBuy(WalletType.Cash),
		handlePayByCard: () => handleBuy(WalletType.Bank),
	};
};

export { useShopPreview };
